import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { SubmitCustGrp2Event } from '../cust-grp2/cust-grp2.component';

@Component({
    selector: 'tt-custgrp2s',
    templateUrl: './cust-grp2s.component.html',
    styleUrls: ['./cust-grp2s.component.css'],
})
export class CustGrp2sComponent implements OnInit {
    public selectedId = '';

    public custgrp2s: CustGrp2Item[] = [];

    constructor(private datatask: DataTaskService) {}

    public async onCustGrp2Submit(event: SubmitCustGrp2Event) {
        await this.loadCustGrp2s();

        if (event.event === 'save') {
            this.selectedId = event.custgrp2_keyno;
        } else {
            this.selectedId = '';
        }
    }

    private async loadCustGrp2s() {
        this.custgrp2s = await this.getCustGrp2s();
    }

    private async getCustGrp2s() {
        return this.datatask.Post(3972);
    }

    private async init() {
        this.loadCustGrp2s();
    }

    ngOnInit(): void {
        this.init();
    }
}

export interface CustGrp2Item {
    custgrp_keyno: string;
    custgrp_name: string;
    orderby: string;
}
